/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_CopyInputs */

const en_tut_copy = /** @type {(inputs: Tut_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const id_tut_copy = /** @type {(inputs: Tut_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Tut_CopyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_copy = /** @type {((inputs?: Tut_CopyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_CopyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_copy(inputs)
	return en_tut_copy(inputs)
});